class MiniCardVariantSelects extends HTMLElement {
  constructor() {
    super();

    this.containers = this.querySelectorAll(".product__small-variant");
    this.miniCard = this.closest(".mini-card-wrapper");
    this.activeSize = document.querySelector("variant-radios input[name='Size']:checked");

    this.addDropdownListeners();
    this.observeMainVariant();
    this.onVariantChange();
    this.addEventListener('change', this.onVariantChange);

    if (this.activeSize) {
      this.updateSizeOnVariantChange(this.activeSize.value);
    }
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.updateVariantInput();
    this.updateDropdownOptions();
    this.updateLabels();
    this.renderProductInfo();
  }

  addDropdownListeners() {
    this.containers.forEach(container => {
      const select = container.querySelector(".card__select");
      const label = container.querySelector(".form__label");
      const dropdown = container.querySelector(".card__dropdown");
      const options = dropdown.querySelectorAll(".card__item");

      if (options.length <= 1) return this.hideSelect(container);

      label.addEventListener("click", () => dropdown.classList.toggle("card__dropdown--active"));

      window.addEventListener("click", event => {
        if (!select.contains(event.target) && dropdown?.classList.contains("card__dropdown--active")) {
          dropdown.classList.remove("card__dropdown--active");
        }
      });

      this.addVariantChangeListener(container, dropdown);
    });
  }

  hideSelect(container) {
    const icon = container.querySelector(".card__select .icon-caret");

    icon.classList.add("hidden");
  }

  addVariantChangeListener(container, dropdown) {
    const options = dropdown.querySelectorAll(".card__item");
    const select = container.querySelector("select");
    const selectOptions = select.querySelectorAll("option");

    options.forEach(option => {
      option.addEventListener("click", () => {
        const value = option.dataset.value;
        const selectedOption = Array.from(selectOptions).find(selectOption => selectOption.value === value);

        if (selectedOption) select.value = selectedOption.value;

        dropdown.classList.remove("card__dropdown--active");

        select.dispatchEvent(new Event('change', { bubbles: true }));
      })
    })
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateVariantInput() {
    const productForm = this.miniCard.querySelector("product-form");
    const input = productForm.querySelector('input[name="id"]');

    input.value = this.currentVariant.id;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const url = `${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.section}`;

    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const price = html.querySelector('.price-item');
        const images = html.querySelectorAll('img');
        const newPrice = this.miniCard.querySelector('.price-item');
        const newImage = this.miniCard.querySelector('.card__media .media img:first-of-type');
        const newHoverImage = this.miniCard.querySelector('.card__media .media img:last-of-type');

        newImage.classList.add('transition');
        newHoverImage.classList.add('transition');

        if (newPrice && price) {
          newPrice.innerHTML = price.innerHTML;
        }

        if (images.length > 0 && newImage && newHoverImage) {
          newImage.outerHTML = images[0].outerHTML;
          newHoverImage.outerHTML = images[1].outerHTML;

          images[0].onload = function () {
            newImage.classList.remove('transition');
          };

          images[1].onload = function () {
            newHoverImage.classList.remove('transition');
          };
        }

        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut, true, this.currentVariant);
      });
  }

  updateLabels() {
    this.containers.forEach((container, index) => {
      const label = container.querySelector(".form__label");
      const text = label.querySelector(".card__label");
      const swatch = label.querySelector(".product__small-swatch");

      text.innerHTML = this.options[index];

      if (swatch) {
        const dropdown = container.querySelector(".card__dropdown");
        const options = dropdown.querySelectorAll(".card__item");

        options.forEach(option => {
          const value = option.dataset.value;

          if (value === this.options[index]) {
            const newSwatch = option.querySelector("span");

            swatch.replaceWith(newSwatch.cloneNode(true));
          }
        });
      }
    });
  }

  updateDropdownOptions() {
    const dropdowns = this.miniCard.querySelectorAll(".card__dropdown");

    dropdowns.forEach((dropdown, index) => {
      const options = dropdown.querySelectorAll(".card__item");

      options.forEach(option => {
        if (option.dataset.value === this.options[index]) option.classList.add("card__item--active");
        else option.classList.remove("card__item--active");
      })
    })
  }

  toggleAddButton(disable = true, text, modifyClass = true, currentVariant) {
    const productForm = this.miniCard.querySelector("product-form");

    if (!productForm) return;

    let button = productForm.querySelector('[name="add"]');
    let addButtonText = productForm.querySelector('[name="add"] > span');
    let personalised = currentVariant.option3 === "Yes";

    if (!button) return;

    if (disable) {
      button.setAttribute('disabled', 'disabled');

      if (text) addButtonText.textContent = text;
    } else {
      button.removeAttribute('disabled');

      addButtonText.innerHTML = window.variantStrings.addToCart;
    }

    if (personalised) {
      addButtonText.innerHTML = window.variantStrings.view;
      button.type = 'button';
      button.onclick = function () {
        window.location.href = `/variants/${currentVariant.id}`;
      };
    } else {
      button.type = 'submit';
      button.onclick = null;
    }

    if (currentVariant && currentVariant.preorder === true) {
      addButtonText.innerHTML = window.variantStrings.preorder;
    }
  }

  observeMainVariant() {
    const radios = document.querySelectorAll("variant-radios input[name='Size']");

    radios.forEach(radio => {
      radio.addEventListener("click", () => this.updateSizeOnVariantChange(radio.value));
    });
  }

  updateSizeOnVariantChange(value) {
    this.containers.forEach(container => {
      const dropdown = container.querySelector(".card__dropdown");
      const options = dropdown.querySelectorAll(".card__item");

      options.forEach(option => {
        if (option.dataset.value === value) option.click();
      });
    });
  }
}

customElements.define("mini-card-variant-selects", MiniCardVariantSelects);